(() => {
  if (!customElements.get('deferred-media')) {
    class DeferredMedia extends HTMLElement {
      constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener('click', this.loadContent.bind(this));
        if (this.dataset.autoplay === "true") {
          this.loadContent(false);
        }
      }

      loadContent(focus = true) {
        if (typeof window.pauseAllMedia === "function") {
          window.pauseAllMedia();
        }
        if (!this.getAttribute('loaded')) {
          const content = new DocumentFragment();
          content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

          this.setAttribute('loaded', true);
          const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
          if (focus) deferredElement.focus();
          if (deferredElement.play) {
            deferredElement.play();
          }
        }
      }
    }

    customElements.define('deferred-media', DeferredMedia);
  }
})();
